import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';

const TablePage = ({
	DefaultTableRP,
	TableHeaderRP,
	NoticePanelRP,
	defaultTable,
	tableHeader,
	noticePanel,
}) => {
	return (
		<Stack gap={2}>
			{tableHeader ?? (TableHeaderRP ? <TableHeaderRP /> : null)}
			{defaultTable ?? (DefaultTableRP ? <DefaultTableRP /> : null)}
			{noticePanel ?? (NoticePanelRP ? <NoticePanelRP /> : null)}
		</Stack>
	);
};

TablePage.propTypes = {
	DefaultTableRP: PropTypes.elementType,
	TableHeaderRP: PropTypes.elementType,
	NoticePanelRP: PropTypes.elementType,
	defaultTable: PropTypes.node,
	tableHeader: PropTypes.node,
	noticePanel: PropTypes.node,
};

export default TablePage;
